<template>
  <div class="personal-center">
    <div class="banner">
      <div class="content">
        <div class="caption">个人中心</div>
        <p>PERSONAL CENTER</p>
      </div>
    </div>
    <div class="content flex-sb">
      <div class="sidebar">
        <el-collapse v-model="activeName">
          <el-collapse-item name="BasicInformation">
            <template slot="title">
              <i class="icon el-icon-user"></i>账号信息
            </template>
            <div
              :class="{ current: showTemponent == 'BasicInformation' }"
              @click="changeTab('BasicInformation')"
              class="tab-item"
            >
              基本信息
            </div>
            <div
              :class="{ current: showTemponent == 'TrainingPayment' }"
              @click="changeTab('TrainingPayment')"
              class="tab-item"
            >
              培训缴费
            </div>
            <div
              :class="{ current: showTemponent == 'InvoiceRecord' }"
              @click="changeTab('InvoiceRecord')"
              class="tab-item"
            >
              发票记录
            </div>
          </el-collapse-item>
          <el-collapse-item name="CertificateDownload">
            <template slot="title">
              <i class="icon el-icon-download"></i>学习证明下载
            </template>
            <div
              :class="{ current: showTemponent == 'CertificateDownload' }"
              @click="changeTab('CertificateDownload')"
              class="tab-item"
            >
              电子证书下载
            </div>
          </el-collapse-item>
          <el-collapse-item name="Course">
            <template slot="title">
              <i class="icon el-icon-receiving"></i>我的收藏
            </template>
            <div
              :class="{ current: showTemponent == 'Course' }"
              @click="changeTab('Course')"
              class="tab-item"
            >
              收藏课程
            </div>
          </el-collapse-item>
          <el-collapse-item>
            <template slot="title">
              <i class="icon el-icon-suitcase"></i>面授申请
            </template>
            <div
              :class="{ current: showTemponent == 'ApplyFace' }"
              @click="changeTab('ApplyFace')"
              class="tab-item"
            >
              申请面授
            </div>
          </el-collapse-item>
        </el-collapse>
        <div
          :class="{ current: showTemponent == 'CommonProblem' }"
          @click="changeTab('CommonProblem')"
          class="question"
        >
          <i class="icon el-icon-warning-outline"></i>常见问题
        </div>
      </div>
      <div class="main-content">
        <Course
          :courseTotal="courseTotal"
          :courseList="courseList"
          :hideType="true"
          @getCourseData="requestCollectList"
          :courseStyleObject="courseStyleObject"
          v-if="showTemponent == 'Course'"
          @handleCancel="handleCancel"
        />
        <template v-if="showTemponent == 'BasicInformation'">
          <BasicInformation
            @getUser="getUser"
            :userInfo="userInfo"
            ref="basicInfor"
          />
        </template>

        <TrainingPayment
          @emitRequestOrder="requestGetOrderList"
          :orderList="orderList"
          :orderTotalNum="orderTotalNum"
          v-if="showTemponent == 'TrainingPayment'"
        />
        <InvoiceRecord
          @emitRequestInvoice="requestInvoiceList"
          :invoiceList="invoiceList"
          :invoiceTotalNum="invoiceTotalNum"
          v-if="showTemponent == 'InvoiceRecord'"
        />
        <ApplyFace
          @emitRequestOffline="requestOfflineList"
          :offlineList="offlineList"
          :offlineTotalNum="offlineTotalNum"
          v-if="showTemponent == 'ApplyFace'"
        />
        <CertificateDownload
          :proveList="proveList"
          :proveTotalNum="proveTotalNum"
          v-if="showTemponent == 'CertificateDownload'"
        />
        <CommonProblem v-if="showTemponent == 'CommonProblem'" />
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import {
  collectList,
  invoiceList,
  getProveList,
  getOrderList,
  getOfflineList,
} from "@/api";
const Course = () => import("@/components/Course.vue");
const CommonProblem = () => import("@/components/CommonProblem.vue");
const BasicInformation = () => import("@/components/BasicInformation.vue");
const TrainingPayment = () => import("@/components/TrainingPayment.vue");
const CertificateDownload = () =>
  import("@/components/CertificateDownload.vue");
const InvoiceRecord = () => import("@/components/InvoiceRecord.vue");
const ApplyFace = () => import("@/components/ApplyFace.vue");
var loadingInstance;
export default {
  name: "Usercenter",
  components: {
    CommonProblem,
    BasicInformation,
    TrainingPayment,
    InvoiceRecord,
    CertificateDownload,
    Course,
    ApplyFace,
  },
  data() {
    return {
      showTemponent: "BasicInformation",
      activeName: "BasicInformation",
      activeTab: "BasicInformation",
      proveList: [],
      proveTotalNum: 0,
      offlineList: [],
      offlineTotalNum: 0,
      userInfo: {
        avatar: "",
        name: "",
        phone: "",
        idCard: "",
      },
      courseStyleObject: {
        "padding-left": "75px",
        "padding-right": "75px",
        background: "#fff",
      },
      courseTypeList: [], //课程类型
      catalogueList: [], //专业目录
      courseList: [],
      courseTotal: 0,
      paymentRecords: [], // 示例数据，根据文档填充
      userInfo: {},
      invoiceList: [],
      orderList: [],
      orderTotalNum: 0,
      invoiceTotalNum: 0,
      orderTotal: 0,
    };
  },
  mounted() {
    this.getUser();
    if (this.$route.query.showTemponent) {
      this.showTemponent = this.$route.query.showTemponent;
      this.activeName = this.$route.query.showTemponent;
      if (this.showTemponent == "TrainingPayment") {
        this.requestGetOrderList();
      }
      if (this.showTemponent == "BasicInformation") {
        setTimeout(() => {
          this.$refs.basicInfor.handelEditUserInfo();
        }, 500);
      }
      if (this.showTemponent == "CertificateDownload") {
        this.requestProveList();
      }
      if (this.showTemponent == "Course") {
        this.requestCollectList();
      }
    }
  },
  methods: {
    getUser() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.showTemponent = tab;
      // 根据tab加载相应数据
      if (tab == "TrainingPayment") {
        this.requestGetOrderList();
      } else if (tab == "Course") {
        this.requestCollectList();
      } else if (tab == "CertificateDownload") {
        this.requestProveList();
      } else if (tab == "InvoiceRecord") {
        this.requestInvoiceList();
      } else if (this.showTemponent == "ApplyFace") {
        this.requestOfflineList();
      }
    },
    handleCancel() {
      this.requestCollectList();
    },
    requestGetOrderList(pageNum = 1) {
      getOrderList({ pageSize: 15, pageNum }).then((res) => {
        if (res.code == 200) {
          this.orderList = res.rows;
          this.orderTotalNum = res.total;
        }
      });
    },
    //收藏列表
    requestCollectList(pageNum = 1) {
      loadingInstance = Loading.service({ fullscreen: true });
      collectList({ pageNum, pageSize: 9 }).then((res) => {
        if (res) {
          this.courseList = res.rows;
          this.courseTotal = res.total;
          loadingInstance.close();
        }
      });
    },
    //发票列表
    requestInvoiceList(pageNum = 1) {
      invoiceList({ pageNum, pageSize: 15 }).then((res) => {
        if (res) {
          if (res.code == 200) {
            this.invoiceList = res.rows;
            this.invoiceTotalNum = res.total;
          }
        }
      });
    },
    //学习证明
    requestProveList(pageNum = 1) {
      getProveList({ pageNum, pageSize: 15 }).then((res) => {
        if (res.code == 200) {
          this.proveList = res.rows;
          this.proveTotalNum = res.total;
        }
      });
    },
    //申请面授
    requestOfflineList(pageNum = 1) {
      getOfflineList({ pageNum, pageSize: 15 }).then((res) => {
        if (res.code == 200) {
          this.offlineList = res.rows;
          this.offlineTotalNum = res.total;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.personal-center {
  background: #f8fbff;
  padding-bottom: 120px;
  .banner {
    min-width: 1600px;
    color: #fff;
    height: 510px;
    background: url("../assets/image/userinfo.png");
    background-size: 100% 100%;
    padding-top: 170px;
    .content {
      padding-left: 150px;
    }
    .caption {
      font-size: 46px;
      font-weight: bold;
    }
    p {
      font-size: 12px;
      padding-top: 5px;
    }
    margin-bottom: 94px;
  }
  .sidebar {
    padding-top: 15px;
    background: #fff;
    width: 306px;
    border: 1px solid #eee;
    height: 1025px;
    /deep/.el-collapse-item__header {
      border: 0;
      font-size: 20px;
    }
    /deep/.el-collapse-item__wrap {
      border: 0;
    }
    /deep/.el-collapse {
      border: 0;
    }
    .icon {
      font-size: 20px;
      padding-left: 28px;
      padding-right: 12px;
    }
    .tab-item {
      color: #000;
      font-size: 18px;
      padding: 20px 20px 0 70px;
      cursor: pointer;
      &.current {
        color: #1265cc;
      }
    }
    .question {
      font-size: 20px;
      padding-top: 10px;
      cursor: pointer;
      &.current {
        color: #1265cc;
      }
    }
  }

  .main-content {
    background: #fff;
    width: 1268px;
    border: 1px solid #eee;
    height: 1025px;
  }
}
</style>
